<template>
  <div>
    <b-alert v-if="errorMessage" show variant="danger">{{ errorMessage }}</b-alert>

    <b-table
      :items="items"
      :fields="fields"
      :busy="loading"
      primary-key="appointment_id"
      responsive
      hover
      show-empty
      empty-text="Sin citas en el periodo."
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

      <template #cell(visit)="{ item }">
        <div>{{ item.visit_date }}</div>
        <div class="small text-muted">{{ item.type_visit || '—' }} · {{ item.facility || '—' }}</div>
      </template>

      <template #cell(visit_status)="{ item }">
        {{ item.visit_status || 'Sin iniciar' }}
      </template>

      <template #cell(origin)="{ item }">
        {{ item.origin === 'request' ? 'Tu solicitud' : 'Afiliado' }}
      </template>

      <template #cell(patient_flow)="{ item }">
        <b-badge :variant="flowBadge(item.patient_flow).variant">{{ flowText(item.patient_flow) }}</b-badge>
        <div v-if="flowDetail(item.patient_flow)" class="small text-muted">{{ flowDetail(item.patient_flow) }}</div>
      </template>
    </b-table>

    <PaginationTable
      :dataMeta="dataMeta"
      :totalUsers="total"
      :perPage="perPage"
      :currentPage="currentPage"
      @page-changed="load"
    />
  </div>
</template>

<script>
import { BAlert, BBadge, BSpinner, BTable } from 'bootstrap-vue'
import agentPlanService from '@/core/services/api/agentPlan'
import PaginationTable from '@/components/PaginationTable'
import { COMMISSION_STATUS_COPY, PATIENT_FLOW_COPY, money, rangeParams, statusBadge } from '@/core/utils/agentPlanDashboard'
import pagedList from './pagedList'

/** Citas de los afiliados y de las solicitudes del agente, con su estado de PatientFlow. */
export default {
  name: 'AgentAppointmentsTable',
  components: { BAlert, BBadge, BSpinner, BTable, PaginationTable },
  mixins: [pagedList],
  props: {
    range: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: [
        { key: 'patient_name', label: 'Paciente' },
        { key: 'visit', label: 'Cita' },
        { key: 'visit_status', label: 'Estado de la visita' },
        { key: 'origin', label: 'Origen' },
        { key: 'patient_flow', label: 'PatientFlow' },
      ],
    }
  },
  watch: {
    range() {
      this.load(1)
    },
  },
  methods: {
    fetchPage(params) {
      return agentPlanService.getAppointments(params)
    },
    extraParams() {
      return rangeParams(this.range)
    },
    flowBadge(flow) {
      return statusBadge(PATIENT_FLOW_COPY, flow && flow.state)
    },
    flowText(flow) {
      const text = this.flowBadge(flow).text
      return flow && flow.state === 'generated' ? `${text} ${money(flow.amount)}` : text
    },
    flowDetail(flow) {
      if (!flow) return ''
      if (flow.state === 'excluded_type') return flow.reason || ''
      if (flow.state !== 'generated') return ''
      if (flow.paid_at) return `Pagada el ${flow.paid_at}`
      const status = COMMISSION_STATUS_COPY[flow.commission_status]
      const label = status ? status.text : (flow.commission_status || '')
      return flow.payable_on ? `${label} · se paga el ${flow.payable_on}` : label
    },
  },
}
</script>
